import { usePredictorStore } from '../../store/predictor/predictorStore';
import { useContext } from 'react';
import { UserContext } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';

export const useGetPrizes = () => {
  const { user } = useContext(UserContext);
  const activePredictor = usePredictorStore((s) => s.activePredictor);
  const nextPredictor = usePredictorStore((s) => s.nextPredictor);

  const prizes = activePredictor?.prizes ?? nextPredictor?.prizes;
  const filteredPrizes = prizes?.filter((prize) => user.currency === prize.prizeCurrencyCode);

  return filteredPrizes?.sort((a, b) => a.prizeMinPosition - b.prizeMinPosition) ?? [];
};
